import { Decoder, field, nullable, object, string } from 'json-bouncer'
import { ParcelDispatcher, parcelDispatcherDecoder } from './ParcelDispatcher'
import { Parcel, parcelDecoder } from './Parcel'

export interface M {
    readonly deliveryName1: string | null
    readonly deliveryName2: string | null
    readonly deliveryName3: string | null
    readonly deliveryName4: string | null
    readonly deliveryFloor: string | null
    readonly deliveryRoom: string | null
    readonly deliveryStreet: string | null
    readonly deliveryHousenumber: string | null
    readonly deliveryZipcde: string | null
    readonly deliveryCity: string | null
    readonly deliveryCountry: string | null
    readonly parcelDispatcher: ParcelDispatcher | null
    readonly parcel: Parcel | null
}

export function decoder(): Decoder<M> {
    return object(
        {
            deliveryName1: field('deliveryName1', nullable(string())),
            deliveryName2: field('deliveryName2', nullable(string())),
            deliveryName3: field('deliveryName3', nullable(string())),
            deliveryName4: field('deliveryName4', nullable(string())),
            deliveryFloor: field('deliveryFloor', nullable(string())),
            deliveryRoom: field('deliveryRoom', nullable(string())),
            deliveryStreet: field('deliveryStreet', nullable(string())),
            deliveryHousenumber: field('deliveryHousenumber', nullable(string())),
            deliveryZipcde: field('deliveryZipcde', nullable(string())),
            deliveryCity: field('deliveryCity', nullable(string())),
            deliveryCountry: field('deliveryCountry', nullable(string())),
            parcelDispatcher: field('parcelDispatcher', nullable(parcelDispatcherDecoder())),
            parcel: field('parcel', nullable(parcelDecoder()))
        },
    )
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/PrismaRequestDeliveryInformation.ts